module.exports = __webpack_public_path__ + "55a8ce1852bb3055784c112a7b8660ed.svg";